const SUGGESTION_ID_FIELDS = ['contentId', 'serviceId', 'id', 'value']

/**
 * @description 生成搜索联想项的稳定标识，避免同名记录共用标题而发生渲染或点击去重冲突。
 * @param {Record<string, any>} item - 搜索联想项。
 * @param {number} index - 联想项在当前列表中的下标，仅在没有业务标识时兜底。
 * @returns {string} 带字段类型前缀的联想项标识。
 */
export function getSuggestionItemKey(item, index) {
  for (const field of SUGGESTION_ID_FIELDS) {
    const value = item?.[field]
    if (value === undefined || value === null) continue

    const normalizedValue = String(value).trim()
    if (normalizedValue) return `${field}:${normalizedValue}`
  }

  return `index:${index}`
}
